/*! Auric predictive search — Shopify Predictive Search API */
(function () {
  'use strict';

  var input = document.querySelector('[data-search-input]');
  var resultsContainer = document.querySelector('[data-search-results]');
  if (!input || !resultsContainer) return;

  var defaultContent = resultsContainer.innerHTML;
  var debounceTimer;
  var controller;

  input.addEventListener('input', function () {
    var term = input.value.trim();
    clearTimeout(debounceTimer);
    if (term.length < 2) {
      resultsContainer.innerHTML = defaultContent;
      return;
    }
    debounceTimer = setTimeout(function () { runSearch(term); }, 220);
  });

  function runSearch(term) {
    if (controller) controller.abort();
    controller = new AbortController();

    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,article,query&resources[limit]=6&resources[options][unavailable_products]=last', { signal: controller.signal })
      .then(function (res) { return res.json(); })
      .then(function (data) { renderResults(data, term); })
      .catch(function (err) { if (err.name !== 'AbortError') console.error(err); });
  }

  function renderResults(data, term) {
    var resources = data.resources.results;
    var products = resources.products || [];
    var collections = resources.collections || [];
    var articles = resources.articles || [];
    var queries = resources.queries || [];

    if (!products.length && !collections.length && !articles.length) {
      resultsContainer.innerHTML = '<p>' + Liquid_no_results(term) + '</p>';
      return;
    }

    var html = '';

    if (queries.length) {
      html += '<div class="flex" style="gap:8px;flex-wrap:wrap;margin-bottom:16px;">';
      queries.forEach(function (q) {
        html += '<a class="btn btn--sm btn--secondary" href="' + q.url + '">' + q.text + '</a>';
      });
      html += '</div>';
    }

    if (collections.length) {
      html += '<p class="predictive-search__group-title">Collections</p>';
      collections.forEach(function (c) {
        html += '<a class="predictive-search__item" href="' + c.url + '"><span>' + c.title + '</span></a>';
      });
    }

    if (products.length) {
      html += '<p class="predictive-search__group-title">Products</p>';
      products.forEach(function (p) {
        html += '<a class="predictive-search__item" href="' + p.url + '">' +
          (p.image ? '<img src="' + p.image + '" alt="" width="56" height="56" loading="lazy">' : '') +
          '<span><span style="display:block;">' + p.title + '</span><span class="text-muted" style="font-size:0.8125rem;">' + p.price + '</span></span></a>';
      });
    }

    if (articles.length) {
      html += '<p class="predictive-search__group-title">Articles</p>';
      articles.forEach(function (a) {
        html += '<a class="predictive-search__item" href="' + a.url + '"><span>' + a.title + '</span></a>';
      });
    }

    html += '<a class="btn btn--secondary" style="margin-top:20px;" href="/search?q=' + encodeURIComponent(term) + '">View all results</a>';
    resultsContainer.innerHTML = html;
  }

  function Liquid_no_results(term) {
    return 'No results for "' + term + '"';
  }
})();
